module.exports = __webpack_public_path__ + "img/Sibiu_6_kl.e28c5738.jpg";